import { useEffect,useState } from "react";
import useFetch from "./useFetch";
import usePost from "./usePost";
import useCurrent from "./useCurrent";


const useLicense = (withCreate=true) =>{
    const {currentTenantId:tenantId} = useCurrent();
    const {data,loading,error,fetchData} = useFetch(
        tenantId ? `${process.env.REACT_APP_Auth_API_BASE_URL}/licenses/tenant/${tenantId}` : null,
        false // Don't auto-fetch if tenantId is not available
    );
    const {data:resultPost,postData} = usePost();
    const [isCreated,setIsCreated] = useState(false);

    const TRAIL_PERIOD_DAYS = 14;
    const [licenseDays,setLicenseDays] = useState(TRAIL_PERIOD_DAYS);
    const [typeLicense , setTypeLicense] = useState('Trail');

    const createLicense = () =>{
        const date = new Date();
        const startDate = new Date();
        const endDate = new Date(date.setDate( date.getDate() + 14 ))
        const _data = {
            tenantId: tenantId,
            companiesCount:1,
            branchesCount:1,
            usersCount:1,
            appIds: ['SALES'] ,
            typeLicense:'Trail',
            startDate: startDate,
            endDate:  endDate,
        };
        postData(`${process.env.REACT_APP_Auth_API_BASE_URL}/licenses`,_data)
        setIsCreated(true)
    }

    useEffect(() => {
        if(resultPost){
            console.log('License Created Success')
        }
    },[resultPost]);

    // Fetch data when tenantId becomes available
    useEffect(() => {
        if(tenantId && !data && !loading){
            fetchData();
        }
    },[tenantId]);

    useEffect(()=>{
        // Handle fetch errors
        if(error){
            console.error('License Fetch Error:', error);
            return;
        }
        
        if(data){
            // Check if API returned error status
            if(data.status === 0){
                console.error('License API Error:', data.message);
                // Handle error case - keep default values
                return;
            }
            
            if(data.data){
                if(data.data.length === 0 && !isCreated && withCreate){
                    createLicense();
                }else if(data.data.length > 0 && data.data[0]){
                    // Safely access the first license item
                    const license = data.data[0];
                    if(license.typeLicense){
                        setTypeLicense(license.typeLicense);
                    }
                    if(license.endDate){
                        const daysDiff =  Math.abs( new Date() - new Date(license.endDate) ) ;
                        if(daysDiff){
                            setLicenseDays(Math.round(daysDiff / 86400000));
                        }
                    }
                }
            }
        }
    },[data, error]);

    return {data,loading,licenseDays,TRAIL_PERIOD_DAYS,typeLicense}
} 


export default useLicense;